<ng-content></ng-content>

<div class="reference-grid-container">
  <en-slider
    [type]="'condensedSlider'"
    [sliderContent]="cont"
    [contentType]="'prismic'"
  ></en-slider>
</div>
